// File: frontend/src/components/history/KartochkaSobytiya.js
// Version: 2.0 (quick-260910-u2q)
// Date: 2026-09-10
// Назначение: КАРТОЧКА СОБЫТИЯ ленты — и только она.
//
// 🔴 ЗАЧЕМ ОТДЕЛЬНЫЙ ФАЙЛ, ЕСЛИ КОМПОНЕНТ ТОТ ЖЕ. Цена РИСУНКА измеряется ПО
//    ЭТОМУ ФАЙЛУ. Пока рисунок жил вперемешку с оболочкой экрана, разделить два
//    числа можно было только суждением по строкам — то есть подгонкой. Файл —
//    это граница измерения, а не косметика каталога. Переезд сделан ОТДЕЛЬНЫМ
//    коммитом «поведение то же», и только потом правился рисунок.
//
// 🔴 ЧЕТЫРЕ СТРОКИ, И КАЖДАЯ ОТВЕЧАЕТ НА СВОЙ ВОПРОС:
//    (1) ЧТО ЭТО — метка разряда, состояние, имя человека, время;
//    (2) ЧТО ПРОИЗОШЛО — заголовок события, крупно;
//    (3) ПОДРОБНОСТИ — описание, свёрнутое по единственному порогу;
//    (4) КТО И ПО КАКОМУ ДЕЛУ — подпись «имя автора · номер дела».
//    До этого всё лежало в ОДНУ строку, и карточка читалась как строка списка.
//
// 🔴 ПОДПИСЬ — ЭТО АВТОР СОБЫТИЯ, А НЕ КЛИЕНТ. Прототип обещал
//    «Andrey Afonin · GEN-2026-000002», и это именно тот, кто СДЕЛАЛ, плюс дело.
//    Имя клиента осталось там же, где было (первая строка): две фамилии рядом в
//    одной подписи были бы неразличимы — читатель не знал бы, где чья.
//
// 🔴 ИМЕНИ, КОТОРОГО НЕ ПРИСЛАЛИ, НА ЭКРАНЕ НЕТ. Карта `actor_names` приходит
//    отдельным полем ответа и содержит только НАЙДЕННЫЕ непустые имена.
//    «Сотрудник» вместо имени было бы выдумкой; подписи просто не будет.
//    Если нет ни автора, ни номера дела — НЕТ И САМОЙ СТРОКИ: пустая подпись
//    читалась бы как «подписать забыли».
//
// 🔴 СОСТОЯНИЕ РИСУЕТСЯ ТОЛЬКО У ТЕХ, У КОГО ОНО ЕСТЬ. Оно приходит ключом в
//    метаданных и переводится ЗАКРЫТЫМ словарём (`historyEvents.js`);
//    незнакомый ключ печатается САМ СОБОЙ и СЧИТАЕТСЯ — правдоподобная
//    подстановка была бы неотличима от настоящего опознания.
//
// 🔴 НИ ОДНОГО hex: цвета приходят классами и токенами палитры.

import React, { useCallback, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import apiService from '../../services/apiService';
import { useAuth } from '../../context/AuthContext';
// 🔴 ДЕРЖАТЕЛЬ ВИДИМОСТИ ИИ — ТОТ ЖЕ, что у кнопки верхней полосы
//    (`Navbar.js:154`) и у самого виджета (`KatifiWidget.js`). Второго списка
//    ролей здесь нет: кнопка «спросить», показанная тому, у кого виджета нет,
//    вела бы в никуда.
import { aiName as aiNameRule, canSeeKatifi } from '../../config/katifiAccess';
import {
    izvestenTip, metkaSostoyaniya, metkaTipa, otmetkaTipa, znachokTipa,
} from '../../config/historyEvents';

const vremyaSobytiya = (iso) => {
    const d = new Date(iso);
    if (!iso || Number.isNaN(d.getTime())) return '—';   // ПРОЧЕРК, А НЕ ВЫДУМАННОЕ ВРЕМЯ
    return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
};

// 🔴 ЕДИНСТВЕННЫЙ ДЕРЖАТЕЛЬ ПОРОГА СВЁРТКИ. Одно и то же число решает ДВА
//    вопроса: показывать ли шеврон и где обрезать текст свёрнутой карточки.
//    Второй держатель (например `line-clamp` в CSS, считающий СТРОКИ, а не
//    символы) согласовать с этим было бы НЕЧЕМ по построению: строки зависят от
//    ширины окна и шрифта. Разойдясь, они дали бы либо шеврон, за которым ничего
//    не появляется, либо обрезанный текст без шеврона.
//    Переехал сюда ЦЕЛИКОМ вместе с обоими потребителями — не раздвоился.
const PREDEL_SVERNUTOGO = 140;

// Урезание свёрнутой карточки. Многоточие НАЗЫВАЕТ обрезку: текст, оборванный
// без знака, читается как весь текст.
const urezat = (tekst) => (tekst.length > PREDEL_SVERNUTOGO
    ? `${tekst.slice(0, PREDEL_SVERNUTOGO)}…`
    : tekst);

// Есть ли что раскрывать. Шеврон, за которым ничего нет, — флаг, который не
// переключает. [[knowledge_decorative_flag]]
// 🔴 ВТОРОЕ ОСНОВАНИЕ ДОБАВЛЕНО 11.09.2026 (quick-260911-1lx): раскрывать есть
//    что и тогда, когда у события ОПОЗНАН ИСТОЧНИК, — за шевроном стоит запрос
//    цитаты. До этого дня у СМС карточка несла заголовок «СМС» и больше ничего:
//    сотрудник видел, что сообщение было в 09:27, и не мог узнать, о чём оно,
//    не уходя с экрана (наблюдение владельца на бою).
//    🔴 СВОЕГО СПИСКА РАЗРЯДОВ «У КОГО ИСТОЧНИК ЕСТЬ» ЗДЕСЬ НЕТ: это было бы
//    третье мнение после `ORIGIN_OF_EVENT` и метаданных писателя. Спрашивается
//    ровно то, что уже вычисляет `atributyIstochnika` — и ответ сервера всё
//    равно сильнее: он может сказать «источника нет по существу», и карточка
//    скажет это словами, а не покажет пустоту.
const estChtoRaskryt = (e) => (e.description || '').length > PREDEL_SVERNUTOGO
    || !!atributyIstochnika(e)['data-source-model'];

// 🔴 ПРОСЛЕЖИВАЕМОСТЬ НЕ ИСЧЕЗЛА, А ПЕРЕЕХАЛА. `source_model`/`source_id`
//    положены писателями НАМЕРЕННО — это связь события со строкой-источником.
//    Из `<pre>` на виду у адвоката они уходят в атрибуты узла, где их видит
//    инспектор и сторож.
//    Первым спрашивается `metadata`: именно её пишут писатели, и она приходит
//    во ВСЕХ ручках. `origin` — производное от неё и служит запасным ответом.
//    🔴 Атрибута НЕТ ВОВСЕ, если источник не опознан: пустой атрибут был бы
//    неотличим от опознанного пустого источника.
const atributyIstochnika = (e) => {
    const meta = (e && e.metadata) || {};
    const origin = (e && e.origin) || null;
    const model = meta.source_model || (origin ? origin.table : null);
    const id = meta.source_id || (origin ? origin.id : null);
    const out = {};
    if (model) out['data-source-model'] = String(model);
    if (id) out['data-source-id'] = String(id);
    return out;
};

// 🔴 ПЯТЬ СОСТОЯНИЙ ЦИТАТЫ, И ГОВОРЯТ ОНИ РАЗНЫМИ СЛОВАМИ — ровно как ответы
//    ручки. Молчаливая пустота на отказе — дефект: человек прочитал бы её как
//    «в источнике ничего нет», а это неправда [[feedback_unknown_is_not_no]].
//    Состояние хранится ЦЕЛИКОМ в одном объекте: два независимых признака
//    («грузим» и «беда») разошлись бы и дали бы вид, которого нет ни у одного
//    ответа сервера.
const SOST_GRUZIM = { rod: 'gruzim' };

const bedaPoOtvetu = (e) => {
    const kod = e && e.status;
    if (kod === 403) {
        return { rod: 'otkaz', tekst: 'Отказано по правам: цитата источника '
            + 'доступна сотрудникам фирмы. Это отказ, а не пустой источник.' };
    }
    if (kod === 404) {
        return { rod: 'net_sobytiya', tekst: 'Сервер говорит, что события с таким '
            + 'номером нет. На экране оно есть — значит лента и база разошлись.' };
    }
    if (kod === 410) {
        return { rod: 'utrata', tekst: (e && e.message)
            || 'Строка-источник УТРАЧЕНА: событие о ней есть, а её самой нет.' };
    }
    // Всё прочее — «спросить не смогли». Это НЕ «источника нет»: измеритель
    // отказал, и сказать об этом надо теми же словами, какими экран уже
    // говорит об отказе ленты.
    return { rod: 'sboj', tekst: (e && e.message) || 'причина не названа' };
};

// Вопрос складывается ИЗ ТОГО, ЧТО УЖЕ НА КАРТОЧКЕ: разряд, заголовок, время,
// имя/телефон звонящего, описание события и номер дела.
const voprosOSobytii = (sobytie, nomerDela, imyaKlienta, tsitataTekst) => {
    const chasti = [
        `Событие истории №${sobytie.id}: ${metkaTipa(sobytie.event_type)}`,
        `«${sobytie.title}»`,
        vremyaSobytiya(sobytie.created_at),
    ];
    if (imyaKlienta) chasti.push(`Клиент: ${imyaKlienta}`);
    if (nomerDela) chasti.push(`дело ${nomerDela}`);
    let tekst = `${chasti.join(' · ')}.`;
    const soderzhanie = sobytie.description || tsitataTekst;
    if (soderzhanie) {
        tekst += `\nТекст/содержание: «${soderzhanie}»`;
    }
    tekst += `\nЧто это значит и что делать дальше?`;
    return tekst;
};

const KartochkaSobytiya = ({ sobytie, imya, avtor }) => {
    const { user } = useAuth();
    const [raskryto, setRaskryto] = useState(false);
    // null — «не спрашивали». Запрошенный однажды ответ ЗАПОМИНАЕТСЯ: повторное
    // сворачивание-раскрытие второго запроса не делает.
    const [tsitata, postavitTsitatu] = useState(null);
    const tip = sobytie.event_type;
    const Znachok = znachokTipa(tip);
    const otmetka = otmetkaTipa(tip);
    const meta = sobytie.metadata || {};
    const nomerDela = meta.case_number || null;
    const kluchSostoyaniya = meta.sostoyanie || null;
    const sostoyanie = metkaSostoyaniya(kluchSostoyaniya);
    const raskryvaemo = estChtoRaskryt(sobytie);
    const estPodpis = !!(avtor || nomerDela);

    // Кнопка рисуется ровно тем, кому виден сам виджет, и имя ИИ берётся у того
    // же держателя: у арендатора без Katifi это Julifi, и подпись обязана
    // называть того, кто на самом деле откроется.
    const vidnaKatifi = canSeeKatifi(user);
    const imyaII = (aiNameRule(user) || '').split(' ')[0];

    const sprositKatifi = useCallback(() => {
        // ЗАПОЛНИТЬ поле и ЗАМОЛЧАТЬ: отправляет человек. Ветка `detail.tekst`
        // живёт в `KatifiWidget.js` рядом с доводом «почему не Manus».
        const tsitataTekst = tsitata && tsitata.rod === 'otvet' && tsitata.otvet && tsitata.otvet.est_istochnik
            ? tsitata.otvet.tsitata
            : null;
        window.dispatchEvent(new CustomEvent('katifi:open', {
            detail: { tekst: voprosOSobytii(sobytie, meta.case_number || null, imya, tsitataTekst) },
        }));
    }, [sobytie, meta.case_number, imya, tsitata]);

    const pereklyuchit = useCallback(() => {
        setRaskryto((bylo) => {
            const stanet = !bylo;
            // Запрос уходит РОВНО ОДИН РАЗ и только на раскрытии: цитата — это
            // переписка клиента, и тянуть её для всех карточек ленты заранее
            // значило бы разослать её тому, кто её не открывал.
            if (stanet && tsitata === null) {
                postavitTsitatu(SOST_GRUZIM);
                apiService.getEventSource(sobytie.id)
                    .then((o) => postavitTsitatu({ rod: 'otvet', otvet: o }))
                    .catch((e) => postavitTsitatu(bedaPoOtvetu(e)));
            }
            return stanet;
        });
    }, [sobytie.id, tsitata]);
    // Тип вынесен в класс — тем же приёмом, каким это делает старая лента
    // (`history-event--<тип>`): по нему карточку можно и оформить, и СВЕРИТЬ с
    // ответом ручки, не гадая по видимой метке.
    return (
        <li className={`fk-hist-card fk-hist-card--${tip}${izvestenTip(tip) ? '' : ' fk-hist-card--chuzhoj'}`}
            {...atributyIstochnika(sobytie)}>
            {/* Отметка источника: её НЕТ у типа вне словаря и у типа, у которого
                источника нет по существу. Цвет — классом, не литералом. */}
            {otmetka ? <span className={`fk-hist-mark fk-hist-mark--${otmetka}`} aria-hidden="true" /> : null}

            {/* СТРОКА 1 — что это. */}
            <span className="fk-hist-line1">
                {Znachok ? <Znachok className="fk-hist-icon" size={16} strokeWidth={1.5} aria-hidden="true" /> : null}
                <span className="fk-hist-type">{metkaTipa(tip)}</span>
                {/* Состояние — только у тех разрядов, у кого оно есть. */}
                {sostoyanie ? (
                    <span className={`fk-hist-state fk-hist-state--${kluchSostoyaniya}`}>{sostoyanie}</span>
                ) : null}
                {/* Имя человека рисуется ТОЛЬКО если оно пришло в карте ответа.
                    Подпись «клиент» вместо имени была бы выдумкой. */}
                {imya ? <span className="fk-hist-who">{imya}</span> : null}
                <span className="fk-hist-time">{vremyaSobytiya(sobytie.created_at)}</span>
                {raskryvaemo ? (
                    <button type="button" className="fk-hist-chev"
                            onClick={pereklyuchit}
                            aria-label={raskryto ? 'Свернуть' : 'Раскрыть'}>
                        <ChevronDown size={14} strokeWidth={1.5} aria-hidden="true" />
                    </button>
                ) : null}
            </span>

            {/* СТРОКА 2 — что произошло. Своей строкой и крупно. */}
            <span className="fk-hist-title">{sobytie.title}</span>

            {/* СТРОКА 3 — подробности. Пустого абзаца НЕТ ВОВСЕ: пустая строка
                выглядела бы как текст, которого не написали, а его просто нет.
                🔴 Шеврон ПЕРЕКЛЮЧАЕТ ВИДИМОЕ: свёрнутая карточка показывает
                урезанный текст, раскрытая — тот же текст целиком. */}
            {sobytie.description ? (
                <p className="fk-hist-desc">
                    {raskryto ? sobytie.description : urezat(sobytie.description)}
                </p>
            ) : null}

            {/* ЦИТАТА ИСТОЧНИКА — ТОЛЬКО ПО ТРЕБОВАНИЮ и только у раскрытой
                карточки. Пять состояний, и каждое своими словами.
                🔴 `Open source` (ссылка «открыть источник») НЕ РИСУЕТСЯ НИ У
                   ОДНОГО из четырёх разрядов, и это РЕШЕНИЕ, а не недоделка.
                   Поимённо, с адресами — чтобы следующий читатель не завёл
                   ссылку в никуда (правило записано в `HistoryPage.js:41-43`):
                     · `call_received` → `/voice` (`pages/VoicePage.js`, 25
                       строк: сводка и настройки агентов). Адреса ОДНОГО звонка
                       там нет вовсе;
                     · `email_received` → `/email-inbox`
                       (`pages/EmailTriagePage.js`) — это СПИСОК очереди,
                       `useParams` в файле 0 раз; сверх того сервер
                       (`endpoints/email_triage.py:23`) пускает только
                       MANAGING_PARTNER/ADMINISTRATOR/SUPERADMIN/CREATOR, то
                       есть PARALEGAL и ATTORNEY получили бы 403;
                     · `lead_created` → `/leads/:id`
                       (`pages/LeadHistoryPage.js`) зовёт ТУ ЖЕ ленту — ссылка
                       вела бы из ленты в ленту;
                     · `sms_message` → экрана нет вовсе: в `App.js` маршрута с
                       sms нет ни одного.
                   Единственный разряд с настоящим действием — `document_uploaded`
                   (`GET /history/documents/{id}/download`, свой рубеж); событий
                   этого разряда сегодня 0, и рисовать ли им кнопку — решение
                   владельца, когда они появятся. То же записано в
                   `deferred-items.md`. */}
            {raskryto && raskryvaemo && tsitata ? (
                <div className="fk-hist-tsitata">
                    {tsitata.rod === 'gruzim' ? (
                        <span className="fk-hist-tsitata-zhdem">Запрашиваю источник…</span>
                    ) : null}

                    {tsitata.rod === 'otkaz' ? (
                        <span className="fk-hist-tsitata-otkaz">{tsitata.tekst}</span>
                    ) : null}

                    {tsitata.rod === 'utrata' || tsitata.rod === 'net_sobytiya' ? (
                        <span className="fk-hist-tsitata-utrata">{tsitata.tekst}</span>
                    ) : null}

                    {tsitata.rod === 'sboj' ? (
                        <span className="fk-hist-tsitata-sboj">
                            Источник спросить НЕ УДАЛОСЬ: {tsitata.tekst}. Это отказ
                            измерителя, а не пустой источник.
                        </span>
                    ) : null}

                    {/* Ответ получен. Сервер различает «источника нет по
                        существу», «источник не опознан» и «цитировать нечего» —
                        все три приходят своей ПРИЧИНОЙ, и она печатается как
                        есть: пересказывать её на клиенте значило бы завести
                        второй текст, который разойдётся с первым. */}
                    {tsitata.rod === 'otvet' && !tsitata.otvet.est_istochnik ? (
                        <span className="fk-hist-tsitata-net">{tsitata.otvet.prichina}</span>
                    ) : null}

                    {tsitata.rod === 'otvet' && tsitata.otvet.est_istochnik ? (
                        <>
                            {tsitata.otvet.tsitata ? (
                                <blockquote className="fk-hist-tsitata-tekst">
                                    {tsitata.otvet.tsitata}
                                </blockquote>
                            ) : (
                                <span className="fk-hist-tsitata-net">
                                    {tsitata.otvet.prichina}
                                </span>
                            )}
                            {/* Обрезка НАЗЫВАЕТСЯ, и предел приходит С СЕРВЕРА:
                                своего числа здесь нет — второй держатель
                                разошёлся бы с `tsitata.PREDEL_TSITATY` молча. */}
                            {tsitata.otvet.urezano ? (
                                <span className="fk-hist-tsitata-pod">
                                    Показано первые {tsitata.otvet.predel} символов —
                                    в источнике текста больше.
                                </span>
                            ) : null}
                        </>
                    ) : null}
                </div>
            ) : null}

            {/* ВОПРОС ОБ ЭТОМ СОБЫТИИ. Рисуется только у раскрытой карточки и
                только тому, кому виден виджет: кнопка, ведущая в отказ, хуже
                отсутствия кнопки. На консилиум (`/ai-paralegal`) она НЕ ВЕДЁТ
                НАРОЧНО — у PARALEGAL и ATTORNEY право `tab:ai_paralegal` ложно,
                и такая кнопка привела бы их в отказ. */}
            {raskryto && vidnaKatifi ? (
                <button type="button" className="fk-hist-vopros" onClick={sprositKatifi}>
                    Спросить {imyaII} об этом событии
                </button>
            ) : null}

            {/* СТРОКА 4 — кто и по какому делу. Нет ни автора, ни дела — нет и
                строки: пустая подпись читалась бы как «подписать забыли». */}
            {estPodpis ? (
                <span className="fk-hist-sign">
                    {avtor ? <span className="fk-hist-actor">{avtor}</span> : null}
                    {avtor && nomerDela ? <span className="fk-hist-sep" aria-hidden="true">·</span> : null}
                    {nomerDela ? <span className="fk-hist-case">{nomerDela}</span> : null}
                </span>
            ) : null}
        </li>
    );
};

export default KartochkaSobytiya;
